

import {
  Box,
  ButtonBase,
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  useTheme, Divider
} from "@material-ui/core";
import { Helmet } from "react-helmet";
import React, { useEffect, useState } from "react";
import axios from "axios";
import parse from "html-react-parser";
import { Link, useNavigate, useParams } from "react-router-dom";


export const Blogs = () => {

  const [loading, setLoading] = useState(true);
  const [ddata, setDData] = useState([])
  const theme = useTheme();
  let history = useNavigate();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  useEffect(() => {
    getData();

  }, []);
  const getData = async () => {
    setLoading(true)
    const formdata = new FormData();

    await axios
      .post(
        "/us/get_all_articles",
        formdata
      )
      .then((res) => {
        if (res.data.status === true) {
          setDData(res.data.data);
          setLoading(false);
          console.log(res.data.data);
        }
      });
  };


  return (
    <div>
      <Helmet>

        <title>Our Blogs | Buy or Sell or Rent Property Online</title>

      </Helmet>
      {loading ? (
        <p style={{ textAlign: 'center' }}>Fetching Data Please wait...</p>
      ) : (
        <>
          {/* <Container maxWidth="md">
            <Box m={4}>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                  <Typography
                    variant="h4"
                    style={{ color: "#7b7b7b" }}
                    textAlign="center"
                    gutterBottom
                  >
                    BLOGS
                  </Typography>
                  <hr style={{ color: "#7b7b7b" }} />
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Container maxWidth="lg" >
            <Box m={2}>
              {ddata.length !== 0 ? (<>
                {ddata.map((i) => {
                  return (
                    <>
                      <ButtonBase
                        component={Link}
                        to={`/single_article_page/${i.article_id}`}
                      >
                        <Grid container justifyContent="center" alignItems="flex-start" spacing={1} mt={3}>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card
                              style={{ background: "none", boxShadow: "none" }}
                            >
                              <CardMedia>
                                {isMatch ? (
                                  <img
                                    src={`http://192.168.29.204:5445/static/articles/${i.article_images.split(",")[0]
                                      }`}
                                    alt="No Image"
                                    width="100%"
                                    style={
                                      {
                                        objectFit: "cover",
                                        borderRadius: "10px"
                                        //   position: "absolute",
                                      }
                                    }
                                  />
                                ) : (
                                  <img
                                    src={`http://192.168.29.204:5445/static/articles/${i.article_images.split(",")[0]
                                      }`}
                                    alt="No Image"
                                    width="90%"
                                    style={{
                                      position: "static",
                                      height: "400px",
                                      borderRadius: "10px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                              </CardMedia>
                              <CardContent
                                style={{ paddingLeft: "0px" }}
                              ></CardContent>
                            </Card>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid
                              container
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              mt={1}
                            >
                              <Typography
                                variant="h4"
                                style={{ display: "inline", color: "#53494c" }}
                              >
                                <b>{i.article_title}</b>
                              </Typography>
                              <Typography variant="body1" gutterBottom >
                                <b>Posted Date : </b> {i.article_published_date}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography
                              // variant="body2"
                              style={{
                                // fontWeight: "normal",
                                color: "#53494c",
                                textAlign: "justify",
                              }}
                            >
                              {i.article_desc && (
                                <>
                                  {parse(
                                    i.article_desc
                                      .slice(0, 350)
                                      .concat(["..."])

                                  )}
                                </>
                              )}

                              <br />

                            </Typography>
                            <hr style={{ width: "100%" }} />
                          </Grid>

                        </Grid>
                      </ButtonBase>
                    </>
                  );
                })}</>) : <p>
                No Results Found.....
              </p>}
            </Box>
          </Container> */}

<Container maxWidth="md">
            <Box m={4}>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                  <Typography
                    variant="h4"
                    style={{ color: "#7b7b7b" }}
                    textAlign="center"
                    gutterBottom
                  >
                    BLOGS
                  </Typography>
                  <hr style={{ color: "#7b7b7b" }} />
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Container maxWidth="lg" >
            <Box m={2}>
              {ddata.length !== 0 ? (<>
                {ddata.map((i) => {
                  return (
                    <>
                      <ButtonBase
                        component={Link}
                        to={`/single_article_page/${i.article_id}`}
                      >
                        <Grid container justifyContent="center" alignItems="flex-start" spacing={1} mt={3}>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card
                              style={{ background: "none", boxShadow: "none" }}
                            >
                              <CardMedia>
                                {isMatch ? (
                                  <img
                                    src={`http://192.168.29.204:5445/static/articles/${i.article_images.split(",")[0]
                                      }`}
                                    alt="No Image"
                                    width="100%"
                                    style={
                                      {
                                        objectFit: "cover",
                                        borderRadius: "10px"
                                        //   position: "absolute",
                                      }
                                    }
                                  />
                                ) : (
                                  <img
                                    src={`http://192.168.29.204:5445/static/articles/${i.article_images.split(",")[0]
                                      }`}
                                    alt="No Image"
                                    width="100%"
                                    style={{
                                      position: "static",
                                      height: "400px",
                                      borderRadius: "10px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                              </CardMedia>
                              <CardContent
                                style={{ paddingLeft: "0px" }}
                              ></CardContent>
                            </Card>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid
                              container
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              mt={1}
                            >
                              <Typography
                                variant="h4"
                                style={{ display: "inline", color: "#53494c" }}
                              >
                                <b>{i.article_title}</b>
                              </Typography>
                              <Typography variant="body1" gutterBottom >
                                <b>Posted Date : </b> {i.article_published_date}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography
                              // variant="body2"
                              style={{
                                // fontWeight: "normal",
                                color: "#53494c",
                                textAlign: "justify",
                              }}
                            >
                              {i.article_desc && (
                                <>
                                  {parse(
                                    i.article_desc
                                      .slice(0, 350)
                                      .concat(["..."])

                                  )}
                                </>
                              )}

                              <br />

                            </Typography>
                            <hr style={{ width: "100%" }} />
                          </Grid>

                        </Grid>
                      </ButtonBase>
                    </>
                  );
                })}</>) : <p>
                No Results Found.....
              </p>}
            </Box>
          </Container> 

        </>)}
    </div>
  );
};

